{
  "contentMenu": {
    "title": "Heading",
    "subTitle": "Subheading",
    "bodyText": "Body text",
    "vignette": "Vignette",
    "preamble": "Preamble",
    "tvListing": "TV listing info",
    "unorderedList": "List",
    "orderedList": "Numbered list",
    "searchImages": "Search images",
    "factboxes": "Search factboxes"
  },
  "numberOfChars": "Number of characters",
  "spelling": {
    "noSuggestions": "No suggestions",
    "loading": "Loading suggestions..."
  },
  "factbox": {
    "headerTitle": "Edit factbox original",
    "modifiedLabel": "The original is from",
    "createdLabel": "Created",
    "lastModifiedLabel": "Last modified",
    "footerTitle": "Changes to the factbox text only apply to this article",
    "factboxNewTitle": "Facts",
    "addSingleLabel": "Create factbox"
  },
  "image": {
    "captionLabel": "Text",
    "bylineLabel": "Photo"
  },
  "footer": {
    "words": "Words",
    "numberOfWords": "Number of words: article (total)",
    "chars": "Characters",
    "numberOfChars": "Number of characters: article (total)",
    "language": "Article language",
    "selection": "Selection",
    "selectionHint": "Counting selected text",
    "selectedWords": "Number of selected words",
    "selectedChars": "Number of selected characters"
  },
  "goToLatestVersion": "Go to latest version",
  "goToLatestVersionShort": "Latest",
  "embargoActive": "Cannot publish directly — embargo active until {{time}}",
  "embargoCheckUnavailable": "Cannot verify embargo. Try again.",
  "addRoleInfo": {
    "editorial": "Add editorial info",
    "internal": "Add internal info"
  },
  "removeInfoConfirm": "Are you sure you want to remove the info?",
  "changeType": "Change type",
  "changeTypeConfirm": "Are you sure you want to change the type of info?",
  "derivedFromTimelessLink": "timeless",
  "derivedFromArticleLink": "article",
  "derivedFromConnector": "and",
  "derivedFromPlanningLink": "planning"
}
